export default __webpack_public_path__ + "static/media/purpureLinkIcon.be0e0336.svg";